import { useQuerystring } from "$routes/_lib/use-querystring";
import { useCreateInvoiceRxdb } from "$routes/patient/[:patientId]/_lib/invoices-v2/use-create-invoice-rxdb";
import { linkToPatientDetails } from "$routes/patient/[:patientId]/links";
import { Box, styled } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

const SubtleButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(0.5),
  width: "100%",
  padding: theme.spacing(1.25),
  marginTop: theme.spacing(0.5),
  border: "none",
  backgroundColor: "transparent",
  color: theme.palette.text.secondary,
  fontSize: "0.75rem",
  fontWeight: 500,
  cursor: "pointer",
  fontFamily: "inherit",
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

export const NewInvoiceAction: FC = () => {
  const { patientUuid } = useQuerystring();
  const { createInvoice } = useCreateInvoiceRxdb(patientUuid);
  const navigate = useNavigate();

  const onCreate = useCallback(async () => {
    const result = await createInvoice();
    if (!result) return;
    navigate(
      linkToPatientDetails({
        patientUuid,
        invoiceId: result.id,
      }),
    );
  }, [createInvoice, navigate, patientUuid]);

  return (
    <Box>
      <SubtleButton
        type="button"
        onClick={onCreate}
        data-testid="invoicing.v2.create.newInvoice"
      >
        <AddIcon fontSize="small" />
        <FormattedMessage
          id="invoicing.v2.newInvoice"
          defaultMessage="New invoice"
        />
      </SubtleButton>
    </Box>
  );
};
